var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "union-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h390v60H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.456 292.974c36.711-21.502 53.155-52.886 62.259-92.555l-.041-.007c-.493-2.951-1.01-6.25-1.565-9.794-1.353-8.645-2.936-18.75-4.972-28.836-10.469-52.063-46.711-90.847-107.588-115.628-56.054-22.812-113.448-26.508-170.981-16.93-9.434 1.572-18.782 3.346-28.128 5.12-22.449 4.26-44.889 8.519-68.491 9.957-37.132 2.277-72.24-2.18-105.218-20.462-9.81-5.433-20.554-9.927-31.274-14.11C-23.063-11.175-75.738-.899-99.972 36.106c-8.156 12.463-13.956 26.258-18.528 40.08-12.772 38.636-9.531 77.746 12.23 116.987 9.922 17.874 25.473 32.186 43.97 45.658 19.06 13.891 39.059 25.786 62.3 33.874V397h390v-88.564c12.192 3.654 24.842 5.179 38.315 3.183 21.275-3.161 41.228-8.739 58.141-18.645z",
    fill: "currentColor",
    clipPath: "url(#union-mobile_svg__a)"
  })));
}
export default SvgUnionMobile;